import { patchRequest } from "../httpMethods";

export const patchTrainerReject = (id) =>
    patchRequest(`trainerUp/${id}/reject`);